import { Button } from '@medly-components/core';
import { MedlyDialogBox, DialogBoxHeader, DialogBoxContent, TopRightVector, TopRightVectorMobile } from './DialogBox.styled';
import React, { useEffect, useState } from 'react';
import BlueVectorSVG from '../../../assets/svg/top_blue_vector.svg';
import BlueVectorMobileSVG from '../../../assets/svg/top_blue_vector_sm.svg';
import coral from '../../../theme/colors/coral';

type DialogBoxProps = {
    title: string;
    content: JSX.Element | string | (JSX.Element | string)[];
    submitButtonLabel?: string;
    cancelButtonLabel?: string;
    open: boolean;
    showSubmit?: boolean;
    loading?: boolean;
    showCancel?: boolean;
    submit?: () => void;
    onClose?: () => void;
    onCancel?: () => void;
};

export const DialogBox: React.FC<DialogBoxProps> = ({
    title,
    content,
    submitButtonLabel = 'Save',
    cancelButtonLabel = 'Cancel',
    open,
    showSubmit = true,
    showCancel = false,
    loading = false,
    submit = () => {
        return;
    },
    onClose = () => {},
    onCancel = () => {
        return;
    }
}) => {
    const [openState, setOpenState] = useState(open);

    useEffect(() => {
        setOpenState(open);
    }, [setOpenState, open]);

    const onCloseHandler = () => {
        setOpenState(false);
        onClose();
    };

    return (
        <MedlyDialogBox open={openState} showCloseIcon={true} onCloseModal={onCloseHandler}>
            <TopRightVector src={BlueVectorSVG} />
            <TopRightVectorMobile src={BlueVectorMobileSVG} />
            {title ? <DialogBoxHeader>{title}</DialogBoxHeader> : null}
            <DialogBoxContent>{content}</DialogBoxContent>
            <MedlyDialogBox.Actions>
                {showCancel ? (
                    <Button
                        style={{ background: 'white', color: coral['500'] }}
                        fullWidth
                        variant="outlined"
                        type="reset"
                        onClick={onCancel}
                        disabled={loading}
                    >
                        {cancelButtonLabel}
                    </Button>
                ) : null}
                {showSubmit ? (
                    <Button isLoading={loading} disabled={loading} fullWidth onClick={submit}>
                        {submitButtonLabel}
                    </Button>
                ) : null}
            </MedlyDialogBox.Actions>
        </MedlyDialogBox>
    );
};

DialogBox.displayName = 'DialogBox';
